type Props = {
  size?: number
  icon?: string
  title?: string
  caption?: string
  bgColor?: string
}

const BoxIcon = ({ icon, size = 20, title, caption, bgColor }: Props) => {
  return (
    <div
      className='w-full p-2 sm:p-4 rounded shadow-md flex flex-col justify-center items-center gap-2.5'
      style={{ backgroundColor: bgColor }}
    >
      {icon && <img src={icon} alt='' width={size} height={size} />}
      <p className='text-[10px] sm:text-sm leading-3 text-gray-900 text-center'>
        {title}
        <br />
        {caption}
      </p>
    </div>
  )
}

export default BoxIcon
